// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCloseHover: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M520,733 C521.104569,733 522,733.895431 522,735 L522,751 C522,752.104569 521.104569,753 520,753 L504,753 C502.895431,753 502,752.104569 502,751 L502,735 C502,733.895431 502.895431,733 504,733 L520,733 Z M514.842903,738.261653 L512,741.104556 L509.157097,738.261653 C508.808254,737.912782 508.242626,737.912782 507.893477,738.261653 L507.261653,738.893477 C506.912782,739.242348 506.912782,739.807949 507.261653,740.157097 L510.104556,743 L507.261653,745.842903 C506.912782,746.191746 506.912782,746.757374 507.261653,747.106523 L507.893477,747.738347 C508.242348,748.087218 508.808254,748.087218 509.157097,747.738347 L512,744.895444 L514.842903,747.738347 C515.191746,748.087218 515.757652,748.087218 516.106523,747.738347 L516.738347,747.106523 C517.087218,746.757652 517.087218,746.192051 516.738347,745.842903 L513.895444,743 L516.738347,740.157097 C517.087218,739.808254 517.087218,739.242626 516.738347,738.893477 L516.106523,738.261653 C515.757652,737.912782 515.192051,737.912782 514.842903,738.261653 Z"
                transform="translate(-502 -733)"
            />
        </svg>
    );
};

export default React.memo(IconCloseHover);
